import {
	Box,
	Card,
	CardActions,
	CardContent,
	CardHeader,
	CardMedia,
	Divider,
	Fade,
	Link,
	makeStyles,
	Typography,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classNames from "classnames";
import { get } from "lodash";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslate } from "react-admin";
import ItemsField from "../bookmaker-deals/fields/ItemsField";
import { APP_URL } from "../config";
import PromoteButton from "./PromoteButton";

const useStyles = makeStyles((theme) => ({
	media: {
		height: 0,
		paddingTop: "56.25%", // 16:9
	},
	avatar: {
		backgroundColor: green[500],
	},
	paused: {
		opacity: 0.8,
	},
	active: {},
	hidden: {
		display: "none",
	},
	divider: {
		marginTop: "1em",
		marginBottom: "1em",
	},
	description: {
		position: "relative",
	},
	showMore: {
		position: "absolute",
		right: "0",
		top: "0",
	},
	card: {
		marginBottom: `${theme.spacing(2)}!important`,
	},
	img: {
		objectFit: "initial",
	},
}));

const ListItem = ({ id, data, cache, onRequestApprovalClick }) => {
	const [showMore, setShowMore] = useState(false);
	const classes = useStyles();
	const translate = useTranslate();
	return (
		<Card
			key={get(data, "id")}
			className={classNames(classes.card, classes[get(data[id], "status")])}
			elevation={4}
		>
			<CardHeader
				title={
					<Typography
						variant="subtitle1"
						style={{ fontWeight: "bold", textTransform: "uppercase" }}
					>
						{get(data[id], "shortname")}
					</Typography>
				}
				disableTypography
			/>
			<CardMedia
				component="img"
				image={`${APP_URL}${get(data[id], "logo_path")}`}
				classes={{
					img: classes.img,
				}}
			/>
			<CardContent>
				<Typography variant="overline" style={{ fontWeight: "bold" }}>
					{translate("resources.deals.name", {
						smart_count: get(data[id], "deals", []).length,
					})}
				</Typography>
				{!!get(data[id], "deals") &&
					get(data[id], "deals").map((deal) => (
						<Typography
							key={deal.id}
							variant="h6"
							style={{ fontWeight: "bold" }}
						>
							<ItemsField source="items" record={deal} />
						</Typography>
					))}
				<Divider className={classes.divider} />
				{get(data[id], "excerpt") ? (
					<Box className={classes.description}>
						{!showMore && (
							<Typography
								className={showMore ? classes.hidden : ""}
								variant="body1"
								color="textSecondary"
								component="p"
								onClick={() => setShowMore(true)}
							>
								{get(data[id], "excerpt")}
							</Typography>
						)}
						<Fade in={showMore}>
							<Typography
								className={!showMore ? classes.hidden : ""}
								variant="body1"
								component="p"
								dangerouslySetInnerHTML={{
									__html: get(data[id], "description"),
								}}
							/>
						</Fade>
						<Link
							href="#"
							onClick={(e) => {
								e.preventDefault();
								setShowMore(!showMore);
							}}
							className={classes.showMore}
						>
							{showMore ? <ExpandLessIcon /> : <ExpandMoreIcon />}
						</Link>
					</Box>
				) : (
					<Typography>&nbsp;</Typography>
				)}
			</CardContent>
			<CardActions style={{ flexDirection: "column", alignItems: "start" }}>
				<PromoteButton
					data={data}
					id={id}
					cache={cache}
					onRequestApprovalClick={onRequestApprovalClick}
				/>
			</CardActions>
		</Card>
	);
};
ListItem.propTypes = {
	id: PropTypes.any.isRequired,
	data: PropTypes.object.isRequired,
	onRequestApprovalClick: PropTypes.func.isRequired,
};
export default ListItem;
